<template>
	<div id="login" class="container">
		<div class="container__form" :class="showForgot ? 'less-margin' : ''">
			<div class="container__form-title">
				<CompanyLogo class="container__form-title__logo" v-if="!showForgot && !showSuccess" />
				<div class="container__form-title__text" v-if="!showForgot && !showSuccess">
					<h2>Núcleo Admin</h2>
				</div>
				<div class="container__form-body">
					<LoginForm
						:isWeb="isWeb"
						@handleForgotForm="handleForgotForm"
						v-if="!showForgot && !showSuccess"
					/>
					<ForgotForm
						:isWeb="isWeb"
						@handleForgotForm="handleForgotForm"
						@handleSuccess="handleSuccess"
						v-else-if="showForgot && !showSuccess"
					/>
					<SuccessSended @handleSuccess="handleSuccess" v-else />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CompanyLogo from '@/components/shared/Icons/CompanyLogo.vue';
import LoginForm from '@/components/modules/Login/LoginForm/LoginForm.vue';
import ForgotForm from '@/components/modules/Login/ForgotForm/ForgotForm.vue';
import SuccessSended from '@/components/modules/Login/SuccessSended/SuccessSended.vue';

export default {
	name: 'Login',
	components: { CompanyLogo, LoginForm, ForgotForm, SuccessSended },
	data: () => ({
		windowWidth: window.innerWidth,
		showForgot: false,
		showSuccess: false,
	}),
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		handleForgotForm() {
			this.showForgot = !this.showForgot;
		},
		handleSuccess() {
			this.showSuccess = !this.showSuccess;
			this.showForgot = false;
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
	},
};
</script>

<style lang="scss">
@import 'Login.scss';
</style>
